import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './components/router'
import VueResource from 'vue-resource'
import SweetAlert from 'sweetalert'
import VeeValidate from 'vee-validate'

import '../node_modules/bulma/css/bulma.css'
import '../node_modules/sweetalert/dist/sweetalert.css'

const dictionary = {
  en: {
    messages: {
      required: function () {
        return "Campo obrigatório"
      },
      email: function () {
        return "Digite um email válido"
      }
    }
  }
}

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(SweetAlert)
Vue.use(VeeValidate)

export {
  router
};



// WEBPACK FOOTER //
// ./src/kernel.js